import { loadGoogleMaps } from "../MapsLoader";
import { Modal, ModalOptionDefault } from "./Modal";

class StreetviewModal {
  private target: HTMLElement;
  private location: { lat: number; lng: number };
  public constructor(target: HTMLElement) {
    this.target = target;

    const latlongExploded = this.target.getAttribute("data-latlong").split(",");
    if (latlongExploded.length == 2) {
      this.location = {
        lat: parseFloat(latlongExploded[0]),
        lng: parseFloat(latlongExploded[1]),
      };
      this.target.addEventListener("click", this.open);
    }
  }

  private open = () => {
    const modal = new Modal();

    const modalOptions: ModalOptionDefault = {
      css_classes: "ovolo-streetview-modal",
      create_callback: (modal_el: JQuery) => {
        this.render(modal_el.find(".ovolo-modal__modal__body")[0]);
      },
      close_callback: (modal_el: JQuery) => {
        modal_el.find(".ovolo-modal__modal__header").html("");
        modal_el.find(".ovolo-modal__modal__body").html("");
      },
    };

    modal.open(modalOptions);
  };

  private render = (modalBody: HTMLElement) => {
    loadGoogleMaps().then(() => {
      const innerChild = document.createElement("div");
      modalBody.appendChild(innerChild);

      const panorama = new google.maps.StreetViewPanorama(innerChild, {
        position: this.location,
      });
    });
  };
}

const targets = document.querySelectorAll(".streetview-open-trigger");
if (targets.length) {
  targets.forEach((target: HTMLElement) => {
    const streetviewModal = new StreetviewModal(target);
  });
}
